import BaseModel from '../core/BaseModel'
export default class HistoryCheckModel extends BaseModel {
    constructor() {
        super({ 
                name: "history_check",
                tableName: 'history_check', 
                label: "Quản lý thất thoát", // Ensure label is correctly set
            },  
            {
                stt: { 
                    name: "stt",
                    label: "STT",
                    class: 'center',
                    computed: (data, index) => {
                        data.stt = index + 1;
                    }
                },
                id: { 
                    name: 'id', 
                    type: "Uuid", 
                    label: 'ID', 
                    primaryKey: true, 
                    display: false
                },
                record_code:{
                    name: 'record_code',
                    type: "String",
                    class: "center",
                    label: 'Mã phiếu nhập',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    computed: (data) => {
                        data.record_code = "";
                    }
                },
                record_created_at: {
                    name: 'record_created_at',
                    type: "Date",
                    class: "center",
                    label: 'Ngày nhập',
                    computed: (data) => {
                        data.record_created_at = "";
                    }
                },
                kind: {
                    refs: "kind {id name}",
                    display: false
                },
                kind_name : { 
                    name: 'kind_name',
                    type: "String",
                    class: "center",
                    label: 'Loại',
                    filter: {
                    type: 'input',
                    match: 'contains'
                    },
                    computed : (data) => {
                        data.kind_name = "";
                    }
                },
                import_number: {
                    name: 'import_number',
                    type: "Number",
                    class: "center",
                    label: 'Số Lượng Nhập',
                    computed : (data) => {
                        data.import_number = "";
                    }
                },
                import_weight: {
                    name: 'import_weight',
                    type: "Number",
                    class: "center",
                    label: 'Khối Lượng Nhập',
                    computed : (data) => {
                        data.import_weight = "";
                    }
                },
                import_dead: {
                    name: 'import_dead',
                    type: "Number",
                    class: "center",
                    label: 'Số Lượng Chết Vận Chuyển',
                    computed : (data) => {
                        data.import_dead = "";
                    }
                },
                import_dead_weight: {
                    name: 'import_dead_weight',
                    type: "Number",
                    class: "center",
                    label: 'Khối Lượng Chết Vận Chuyển',
                    computed : (data) => {
                        data.import_dead_weight = "";
                    }
                },
                number_die: {
                    name: 'number_die', 
                    type: "Number", 
                    class: "center",
                    label: 'Số Lượng Chết Nuôi',
                },
                weight_die: {
                    name: 'weight_die', 
                    type: "Number", 
                    class: "center",
                    label: 'Khối Lượng Chết Nuôi',
                    computed : (data) => {
                        data.weight_die = "";
                    }
                },
                // record_details: {
                //     refs: "record_details {import_dead import_dead_weight}",
                //     display: false
                // },
            },
        )
    }

}